// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5f8f1301","239":"c26d0b2a","455":"6c89c2f3","777":"8a635561"}[chunkId] + ".chunk.js";
};